import React from 'react';
import { ALLOW_FONT_SCALING } from './constants';

const Text = __NATIVE__ ? require('react-native').Text : null;

function Br() {
  return __NATIVE__ ? (
    <Text allowFontScaling={ALLOW_FONT_SCALING}>{'\n'}</Text>
  ) : (
    <br />
  );
}

Br.displayName = 'Br';
export default Br;
